import { render, staticRenderFns } from "./default-list.vue?vue&type=template&id=c6005846&"
import script from "./default-list.vue?vue&type=script&lang=ts&"
export * from "./default-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports